import { PLAN_PRO, PLAN_TEAM } from '@/constants/userSubscriptionPlans'
import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum SHARE_PERMISSION {
  ACCESS_TAB = 'ACCESS_TAB',
  PASSWORD_PROTECT = 'PASSWORD_PROTECT',
  ONLY_PROJECT_MEMBERS = 'ONLY_PROJECT_MEMBERS',
  CHANGE_SHARE_SETTINGS_TYPE = 'CHANGE_SHARE_SETTINGS_TYPE',
  CHANGE_LINK_EDiT_PERMISSION_TYPE = 'CHANGE_LINK_EDiT_PERMISSION_TYPE',
  MANAGE_PROJECT_MEMBERS = 'MANAGE_PROJECT_MEMBERS',
  SET_PROJECT_MEMBER_AS_COPYWRITER = 'SET_PROJECT_MEMBER_AS_COPYWRITER',
}

export const getSharePermissionsMatrix = (): Record<
  SHARE_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [SHARE_PERMISSION.ACCESS_TAB]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [SHARE_PERMISSION.ONLY_PROJECT_MEMBERS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [SHARE_PERMISSION.PASSWORD_PROTECT]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [SHARE_PERMISSION.CHANGE_SHARE_SETTINGS_TYPE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [SHARE_PERMISSION.CHANGE_LINK_EDiT_PERMISSION_TYPE]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.FREE_ANONYMOUS]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: {
        type: PERMISSION_TYPE.NO,
      },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: {
        type: PERMISSION_TYPE.NO,
      },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [SHARE_PERMISSION.MANAGE_PROJECT_MEMBERS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [SHARE_PERMISSION.SET_PROJECT_MEMBER_AS_COPYWRITER]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.TRIAL_LOGGED]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.FREE_ANONYMOUS]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.FREE_LOGGED]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NO,
        badge: PLAN_TEAM,
      },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.NO, badge: PLAN_TEAM },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
